"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TimeModel {
    constructor(data) {
        this.order = data.order;
        this.name = data.name;
        this.samplesAssigned = data.samplesAssigned;
        this.samplesTotalThisTime = data.samplesTotalThisTime;
    }
    get collectOrder() {
        return this.order;
    }
    get collectName() {
        return this.name;
    }
    get collectSamplesAssigned() {
        return this.samplesAssigned;
    }
    get collectSamplesTotalThisTime() {
        return this.samplesTotalThisTime;
    }
}
exports.default = TimeModel;
